import { createFileRoute } from "@tanstack/react-router"
import AppLayout from "~/layouts/AppLayout"
import { WebhookList } from "~/components/Settings/WebhookSettings/WebhookList"

function Webhooks() {
  return (
    <AppLayout>
      <div className="flex flex-col gap-6 p-6">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold tracking-tight">Webhooks</h1>
          <p className="text-muted-foreground">
            Manage webhook endpoints to receive real-time notifications about events in your account.
          </p>
        </div>

        <WebhookList />
      </div>
    </AppLayout>
  )
}

export const Route = createFileRoute("/webhooks")({
  component: Webhooks,
})
